/**
 * SegmentGroup — Grupo de botones toggle para filtros rápidos.
 */
import type { FilterOption } from './types'

interface SegmentGroupProps {
  options: FilterOption[]
  value: string
  onChange: (value: string) => void
  color?: 'blue' | 'amber' | 'purple' | 'slate'
  label?: string
}

const colorMap = {
  blue: 'bg-primary text-on-primary',
  amber: 'bg-warning-fill text-white',
  purple: 'bg-purple-600 text-white',
  slate: 'bg-slate-700 text-white',
}

export function SegmentGroup({ options, value, onChange, color = 'blue', label }: SegmentGroupProps) {
  const activeCls = colorMap[color]
  return (
    <div className="flex items-center gap-1.5">
      {label && <span className="text-xs font-medium text-content-subtle mr-0.5">{label}</span>}
      <div className="flex rounded-lg border border-divider overflow-hidden bg-surface">
        {options.map(opt => (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-2.5 py-1.5 text-xs transition-colors whitespace-nowrap
              ${value === opt.value ? activeCls : 'text-content-muted hover:bg-soft'}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )
}
